<template>
  <div>
    <catalog-table
      :tableHeaders="tableHeaders"
      :tableFilters="tableFilters"
      :propsToSearch="tableSearchableProps"
      :tableData="editedWorkers"
      :actions="tableActions"
      :loadingContentProps="loadingContentInfo"
      :pageSize="1000"
      hideFooter
      hidePageSize
    >
      <template slot="search-toolbar-actions">
        <md-button class="md-success" @click="addItem">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar
        </md-button>
      </template>
    </catalog-table>

    <modal v-if="editModal" @close="editModalHide">
      <template slot="body">
        <staff-edit
          :crewId="idCrew"
          :actualWorkers="editedWorkers"
          :title="editModalTitle"
          @saved="updateItem"
          @error="hideEdit"
        ></staff-edit>
      </template>
    </modal>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import { CatalogTable } from "@/components/";
import { Modal } from "@/components";
import StaffEdit from "./EditStaff";

const loadingContentInfo = {
  emptyLabel: "Cuadrilla vaciá",
  emptyDescription:
    "Agregue trabajadores a la cuadrilla utilizando el botón superior.",
  emptyIcon: "people_outline",
};

export default {
  name: "CustomerStaff",
  components: {
    CatalogTable,
    Modal,
    StaffEdit,
  },

  props: {
    workers: {
      type: Array,
      required: false,
    },
    idCrew: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadingContentInfo,
      editedWorkers: [],
      editModal: false,
      editModalTitle: "Añadir Trabajador a Cuadrilla",
      tableHeaders: {
        name: "Nombre",
        role: "Tipo de Trabajo",
      },
      tableFilters: {},
      tableSearchableProps: ["name"],
      tableActions: [
        {
          icon: "close",
          exe: this.deleteItem,
        },
      ],
    };
  },
  methods: {
    editModalHide() {
      this.editModal = false;
    },
    deleteItem(c) {
      this.$confirmMessage({ text: "Confirme que desea elimiar" }, () => {
        return catalogService
          .delete("crew/worker", c)
          .then(() => {
            const temp = this.editedWorkers.indexOf(c);
            this.editedWorkers.splice(temp, 1);
            this.$successMessage({
              title: "Borrado",
              text: "Se ha borrado el registro",
            });
          })
          .catch(this.$fireErrorResponse);
      });
    },
    updateItem(updated) {
      this.hideEdit();
      //FIXME: no store in update
      catalogService
        .create("crew/worker", updated)
        .then((worker) => {
          catalogService
            .fetch("crew/worker", { id: worker.id, noStore: true })
            .then((response) => {
              const aux = {
                workerId: response.worker.Worker_id,
                JBuserId: response.worker.Worker_JBUser_id,
                crewId: response.crew,
                id: response.id,
                name: response.worker.Worker_JBUser_full_name,
                role: response.worker.Worker_role,
                roleId: response.worker.Worker_role_id,
              };
              this.editedWorkers.push(aux);
            });
          this.$successMessage({ title: `Trabajador Añadido a Cuadrilla` });
        })
        .catch(this.$fireErrorResponse);
    },

    addItem() {
      this.editModalTitle = "Agregar Trabajador de Cuadrilla";
      this.currentItem = {};
      this.editModal = true;
    },

    hideEdit() {
      this.editModal = false;
    },
    consultElement(url) {
      catalogService.fetch(url);
    },
  },

  mounted() {
    if (this.$props.workers) {
      this.editedWorkers = this.$props.workers;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/Crews/Staff.vue